import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";
import { moduleName as recordsModuleName } from "../../../../records";
import { machineDenominationLookupConfig } from "./denomination";
import { machineThemeLookupConfig } from "./theme";
import { machineSectionLookupConfig } from "./section";
import { machineCabinetTypeLookupConfig } from "./cabinetType";
import { machineGameTypeLookupConfig } from "./gameType";
import { machineModelLookupConfig } from "./model";
import { machineDisplayConfig } from "./display";
import { machineGameCategoryLookupConfig } from "./gameCategory";

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

angular
  .module(vsModuleName, [recordsModuleName])
  .config(machineCabinetTypeLookupConfig)
  .config(machineDenominationLookupConfig)
  .config(machineGameTypeLookupConfig)
  .config(machineManufacturerLookupConfig)
  .config(machineModelLookupConfig)
  .config(machineSectionLookupConfig)
  .config(machineThemeLookupConfig)
  .config(machineDisplayConfig)
  .config(machineGameCategoryLookupConfig);
